module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("knyj0"))).then(() => module.bundle.root('jnagv'));